module.exports = __webpack_public_path__ + "static/media/foto_4.d0901d40.png";